import React from "react";
import CategoryList from "./CategoryList";
import CategorySearch from "./CategorySearch";

export const Category = () => {
  return (
    <div>
      <CategorySearch />
    </div>
  );
};
